import ErrorWithCause from '@helpers/ErrorWithCause';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
import axios from 'axios';
const checkRegistrationAvailability = async ({ userHandle, userEmail, }) => {
    try {
        return await axios.get(`${SYMFONY_API_BASE_URL}/api/user/availability/v1`, {
            params: { userHandle, userEmail },
        });
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default checkRegistrationAvailability;
